module.exports = __webpack_public_path__ + "img/charging-hub-suggestion-semipublic.0f77d26c.png";